import { DataTable, ExtendedColumnDef } from "components/Datatable";
import { IEvidenceRegister } from "src/@types/evidence-register";

export default function Table({
  columns,
  data,
  isFetching = false,
}: {
  data: IEvidenceRegister[];
  columns: ExtendedColumnDef<IEvidenceRegister>[];
  isFetching?: boolean;
}) {
  return (
    <>
      <DataTable
        data={data}
        columns={columns}
        emptyMessage="Ops! Esta divergência não está mais disponível. Por favor, entre em contato com o seu tesoureiro e solicite um novo link para resposta."
        isLoading={isFetching}
      />
    </>
  );
}
